export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/dealer/addDealerFormAdmin',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allDealers'],
       
    })
